export enum CostType {
  PURCHASE = 'PURCHASE',
  REMAINDER = 'REMAINDER',
  MOH = 'MOH',
  BURDEN = 'BURDEN',
  LABOUR = 'LABOUR',
  RAW_MATERIAL = 'RAW_MATERIAL',
  TOTAL = 'TOTAL',
}
